import { render } from "./depollutionCard.vue?vue&type=template&id=e904c21a&scoped=true"
import script from "./depollutionCard.vue?vue&type=script&lang=js"
export * from "./depollutionCard.vue?vue&type=script&lang=js"

import "./depollutionCard.vue?vue&type=style&index=0&id=e904c21a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e904c21a"]])

export default __exports__